import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button15Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M9 18C4.02944 18 -6.10673e-07 13.9706 -3.93402e-07 9C-1.76132e-07 4.02944 4.02944 -6.10673e-07 9 -3.93402e-07C13.9706 -1.76132e-07 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM8.75 7.5C7.50736 7.5 6.5 6.49264 6.5 5.25C6.5 4.00736 7.50736 3 8.75 3C9.99264 3 11 4.00736 11 5.25C11 6.49264 9.99264 7.5 8.75 7.5ZM6.5 13.25C6.5 14.4926 7.50736 15.5 8.75 15.5C9.99264 15.5 11 14.4926 11 13.25C11 12.0074 9.99264 11 8.75 11C7.50736 11 6.5 12.0074 6.5 13.25Z" />
  </SvgIcon>
);

export default PO28Button15Icon;
